export class CampusInfo {
    public id: number;
    public name: string;
    public info: string;
}

// Campus Info
export const CAMPUS_INFOS: CampusInfo[] = [
  {
    id: 1,

    name: "THU THIEM",
    info: "Thu Thiem Campus (Kindergarten – Year 13)<br>264 Mai Chi Tho (East-West Highway), Binh Trung Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3742 4040",
  },
  {
    id: 1,

    name: "THAO DIEN",
    info: "Thao Dien Campus (Kindergarten – Year 6)<br>APSC Compound 36 Thao Dien Road, An Khanh Ward | Ho Chi Minh City | Vietnam<br>T: +84 28 3744 6960 <br><br> Lotus Campus (Kindergarten) | Lotus Road<br> Cherry Blossom Campus (Year 1 – Year 6) | Cherry Blossom Road<br>T: +84 28 3744 6960",
  },
];



// WEBPACK FOOTER //
// ./src/common/modules/core/models/CampusInfo.ts